var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogged)?_c('div',{staticClass:"base-user"},[_c('div',{staticClass:"base-user__phone"},[_vm._v(_vm._s(_vm.phone))]),_c('button',{staticClass:"base-user__logout",attrs:{"type":"button"},on:{"click":_vm.onLogout}},[_c('base-icon',{attrs:{"name":"exit-outline","width":"24","height":"24"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }